import DOMPurify from 'dompurify' 

export function HTMLElement(props: {
    as: React.ElementType,
    html: string,
    config?: DOMPurify.Config,
    className?: string,
    [x:string]: any,
}) {
    const {as, html, config} = props;
    const As = as;

    let container = document.getElementById("script-container");
    let scriptsrcs: string[] = [];

    if (container) {
        container.innerHTML = html;

        // Trova e valuta tutti gli script inclusi nel contenuto
        var scripts = container.getElementsByTagName("script");

        for (var i = 0; i < scripts.length; i++) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            

            if (
                scripts[i].src &&
                !scriptsrcs.includes(scripts[i].src)
            ) {
                scriptsrcs.push(scripts[i].src);
                script.src = scripts[i].src;
                script.async = scripts[i].async;
                script.defer = scripts[i].defer;
            } else {
                script.text = scripts[i].innerHTML;
            }

            document.head.appendChild(script);
        }

        container.innerHTML = '';
    }

    const DOMPurifySanitize = DOMPurify.sanitize(html, config ?? {});

    let rest = {
        ...props,
        as: undefined,
        html: undefined,
        config: undefined
    };

    return <As
        dangerouslySetInnerHTML={{__html: DOMPurifySanitize}}
        className={rest.className}
        {...rest}
    />
}